module.exports = __webpack_public_path__ + "static/media/popup-dia-del-padre.1814105b.png";